module.exports = __webpack_public_path__ + "static/media/bg-2.d4866794.png";